<template>
  <div ref="qrcodeRef" class="qrcode-view"></div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'QRCodeView',
  props: {
    text: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 240
    }
  },
  mounted() {
    this.renderQRCode()
  },
  watch: {
    text() {
      this.renderQRCode()
    },
    size() {
      this.renderQRCode()
    }
  },
  methods: {
    renderQRCode() {
      const el = this.$refs.qrcodeRef
      if (!el || !this.text) {
        return
      }

      el.innerHTML = ''
      new QRCode(el, {
        text: this.text,
        width: this.size,
        height: this.size,
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  }
}
</script>

<style scoped>
.qrcode-view {
  display: inline-block;
  width: 240px;
  height: 240px;
}

.qrcode-view :deep(img),
.qrcode-view :deep(canvas) {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
